import React from 'react';
import { assignIdsToStruc } from '../../../../../utils/helper';
// import ApplicationHeading from '../../application-heading/ApplicationHeading';
import AbschlussVN from './content/AbschlussVN';
import AnlagenVN, { getFormStrucAnlagenVN } from './content/AnlagenVN';
import ProjektDatenVN from './content/ProjektdatenVN';
import PersonalKostenVN from './content/kosten/personal-kosten/PersonalKostenVN';
// import SachKostenVN from './content/kosten/sach-kosten/SachkostenVN';
import VerwendungsNachweisSchema from '../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { get } from 'lodash';
import { ANTRAG_TYP } from '../../../../../lib/constants/constant';
import BescheidVN, { getFormStrucBescheidVN } from './content/BescheidVN';
const VN_P = VerwendungsNachweisSchema.attributes;

export const VerwendungsnachweisStructure = (application: any, allfoerderprogramms: any, _readOnly: boolean) => {
	let nachweisType = get(application, VN_P.Allgemein_Nachweistyp.path, '').trim();
	let formStruc: any = [
		{
			label: 'Projektdaten',
			content: <ProjektDatenVN />,
		},
		{
			label: 'Kosten',
			// content: <ApplicationHeading title='Kosten' />,
			content: <PersonalKostenVN />,
			// children: [
			// 	{
			// 		label: 'Personalkosten',
			// 	},
			// 	{
			// 		label: 'Sachkosten',
			// 		content: <SachKostenVN />,
			// 	},
			// ],
		},
		...(nachweisType === ANTRAG_TYP.Verwendungsnachweis ?
			[
				{
					label: 'Unterlagen',
					content: <AnlagenVN />,
					formStruc: getFormStrucAnlagenVN(application, allfoerderprogramms),
				},
			] :
			[])
		,
		{
			label: 'Abschluss',
			content: <AbschlussVN />,
		},
		...(get(application, `${VN_P.Allgemein_Generierte_Pruefmitteilung.path}.id`) ? [
			{
				label: 'Prüfmitteilung',
				content: <BescheidVN />,
				formStruc: getFormStrucBescheidVN(),
			},
		] : []),
	];

	return assignIdsToStruc(formStruc);
};
